import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Fig.dtos';

import {
    ACTION_PATIENTREPORTEDFORMS_LOAD,
    ACTION_PATIENTREPORTEDFORMS_LOAD_BY_ID,
    ACTION_PATIENTREPORTEDFORMS_LOAD_BY_PATIENT_ID,
    ACTION_PATIENTREPORTEDFORMS_LOAD_BY_PATIENT_IDENTIFIER,
    ACTION_PATIENTREPORTEDFORMS_LOAD_SUCCESS,
    ACTION_PATIENTREPORTEDFORMS_LOAD_FAILURE,

    ACTION_PATIENTREPORTEDFORMS_SAVE,
    ACTION_PATIENTREPORTEDFORMS_SAVE_SUCCESS,
    ACTION_PATIENTREPORTEDFORMS_SAVE_FAILURE,

    ACTION_PATIENTREPORTEDFORMS_CREATE,
    ACTION_PATIENTREPORTEDFORMS_CREATE_SUCCESS,
    ACTION_PATIENTREPORTEDFORMS_CREATE_FAILURE,

    ACTION_PATIENTREPORTEDFORMS_CLEAR,
    PatientReportedFormAction
} from '../../actions/forms/patientReportedForm';

import { RequestState } from "../../enumerations/RequestState";
import { IRequestState } from "../index";
import { updateFailureIndexToId } from "../../helpers/formErrorHelper";

export interface IPatientReportedFormState {
    formData: Dtos.PatientReportedForm | Dtos.PatientReportedForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    createState: IRequestState;
}

const initialState: IPatientReportedFormState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState
};


function loading(state: IPatientReportedFormState, isLoading: boolean): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IPatientReportedFormState,
    formData: Dtos.PatientReportedForm | Dtos.PatientReportedForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[], responseStatus: Dtos.ResponseStatus
): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function loadFailure(state: IPatientReportedFormState, responseStatus: Dtos.ResponseStatus): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function saving(state: IPatientReportedFormState, isSaving: boolean): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IPatientReportedFormState,
    formData: Dtos.PatientReportedForm | Dtos.PatientReportedForm[],
    formState: Dtos.RegistrationFormState,
    responseStatus: Dtos.ResponseStatus
): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IPatientReportedFormState, responseStatus: Dtos.ResponseStatus): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        }
    });

    return newState;
}

function creating(state: IPatientReportedFormState, isCreating: boolean): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IPatientReportedFormState,
    formData: Dtos.PatientReportedForm,
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[]
): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IPatientReportedFormState, responseStatus: Dtos.ResponseStatus): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IPatientReportedFormState): IPatientReportedFormState {
    const newState: IPatientReportedFormState = update(initialState, {});

    return newState;
}

const PatientReportedFormReducer: Reducer<IPatientReportedFormState> = (state: IPatientReportedFormState = initialState, action: PatientReportedFormAction) => {
    switch (action.type) {
        case ACTION_PATIENTREPORTEDFORMS_LOAD:
        case ACTION_PATIENTREPORTEDFORMS_LOAD_BY_ID:
        case ACTION_PATIENTREPORTEDFORMS_LOAD_BY_PATIENT_ID:
        case ACTION_PATIENTREPORTEDFORMS_LOAD_BY_PATIENT_IDENTIFIER:
            return loading(state, true);
        case ACTION_PATIENTREPORTEDFORMS_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_PATIENTREPORTEDFORMS_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_PATIENTREPORTEDFORMS_SAVE:
            return saving(state, true);
        case ACTION_PATIENTREPORTEDFORMS_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_PATIENTREPORTEDFORMS_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_PATIENTREPORTEDFORMS_CREATE:
            return creating(state, true);
        case ACTION_PATIENTREPORTEDFORMS_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_PATIENTREPORTEDFORMS_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_PATIENTREPORTEDFORMS_CLEAR:
            return clear(state);
    }

    return state;
}

export default PatientReportedFormReducer;